export default "__VITE_ASSET__CEgsaf2q__"